import * as styles from '../../components/PropertyCell/PropertyCell.scss';
import checkIsForeignAddress from '../../helpers/checkIsForeignAddress';

const getButtonsConfig = (data, handlers) => {
  const {
    isActive,
    promoted,
    autoJumpEnabled,
    isTopPromotedProperty,
    suspended,
    editButtonText,
    openDetailsButtonText,
    upgradePackageButtonText,
    activeButtonText,
    inactiveButtonText,
    makeActiveText,
    makeInactiveText,
    jumpToTopText,
    canMoveToTop,
    shareButtonText,
    movePropertyToTop,
    addressData,
    id
  } = data;

  let activeInactiveTitle;
  let activeInactiveText;
  let activeInactiveIcon;

  if (isActive) {
    activeInactiveTitle = makeInactiveText;
    activeInactiveText = inactiveButtonText;
    activeInactiveIcon = 'active';
  } else {
    activeInactiveTitle = makeActiveText;
    activeInactiveText = activeButtonText;
    activeInactiveIcon = 'inactive';
  }
  const moveToTop = () => movePropertyToTop(id);
  const isForeign = checkIsForeignAddress(addressData);

  return {
    share: {
      props: {
        onClick: handlers.handleShare,
        disabled: (!isActive || suspended)
      },
      icon: 'share',
      title: shareButtonText
    },
    edit: {
      props: {
        onClick: handlers.handleEdit
      },
      icon: 'edit',
      title: editButtonText
    },
    jumpToTop: {
      props: {
        className: 'btnToTop',
        onClick: moveToTop,
        disabled: (!isActive || !canMoveToTop)
      },
      icon: `jump-to-top${(!isActive || !canMoveToTop) ? '-disabled' : ''}`,
      title: jumpToTopText
    },
    secondJumpToTop: {
      props: {
        className: styles.secondJump,
        onClick: handlers.handleSecondJump,
        disabled: (!isActive || suspended)
      },
      icon: 'second-jump-to-top',
      title: ''
    },
    preview: {
      props: {
        onClick: handlers.openDetailsPopup
      },
      icon: 'preview',
      title: openDetailsButtonText
    },
    activity: {
      props: {
        onClick: handlers.toggleActivity,
        title: activeInactiveTitle,
        className: 'activityButton'
      },
      icon: isActive ? 'icon icon-inactive' : 'icon icon-active',
      title: activeInactiveText
    },
    upgradePackage: {
      props: {
        className: styles.upgradePackage,
        onClick: handlers.upgradePackage,
        title: 'upgradePackage',
        disabled: (!isActive || suspended || promoted || autoJumpEnabled || isTopPromotedProperty || isForeign)
      },
      icon: 'package-icon',
      title: upgradePackageButtonText
    }
  };
};

export default getButtonsConfig;
